import { z } from "zod";
import type { TFunction } from "i18next";
import type { CopyFormValues, CopyValues } from "./types";

type CreateCopySchemaContext = {
    t: TFunction;
    type: string;
    values: CopyValues | null;
};

export const createCopySchema = ({ t, type, values }: CreateCopySchemaContext) => {
    const isScheduleContext = ["team", "home"].includes(type);

    return z
        .object({
            users: z.array(z.any()).optional(),
            day: z.union([z.string(), z.array(z.string())]).optional(),
        })
        .superRefine((formValues: CopyFormValues, ctx) => {
            const usersRequired = isScheduleContext
                ? type === "team" && !!values?.type && !["day", "bulk", "bulk-day"].includes(values.type)
                : values?.type === "row" || values?.type === "cell";

            if (usersRequired && !formValues.users?.length) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    path: ["users"],
                    message: isScheduleContext ? t("should-select-at-least-one-user") : t("required-users"),
                });
            }

            if (!isScheduleContext) {
                const day = formValues.day;
                const dayEmpty = Array.isArray(day) ? day.length === 0 : !day;

                if (dayEmpty) {
                    ctx.addIssue({
                        code: z.ZodIssueCode.custom,
                        path: ["day"],
                        message: values?.type === "row" ? t("required-day") : t("required-one-day"),
                    });
                }
            }
        });
};

export type CopySchema = ReturnType<typeof createCopySchema>;
